import { ContainerElement } from '@typedream/core';
import { Path } from 'slate';
import { createMachine } from 'xstate';

// eslint-disable-next-line operator-linebreak
export const syncedMachine =
// eslint-disable-next-line max-len
/** @xstate-layout N4IgpgJg5mDOIC5QGUCeA7AxpAsgQ0wAsBLdMAOmQFcoZYAXYge3VgCEmAPcgSQgBswAYgDyAOQD6yABIiA6hIAqAJQCCY5AGEAMgFVkPcVICi245sWGxAbQAMAXUSgADk1jFGLJyE6IAzAAsAeQAbACcAKwATADsABwxEX5xEWEhMQA0IKiIAIwRtuSRcX4hUWElqbklAL41WWhYuAQkZJQ0dJ6sHNzIhEwA7qRQAATUtHBdIz2iksim5ooSxgAaPMiWYgDiSmoaOvpWdo5IIK7uXd6+CH5RhWExuX5+8X62IbZxUSFZOTe2UXIcRCuQeMVuuSCYVsETqDQw2Ag+CIpAo406zG6XEo-SG6FG6MmmOmXFmEh0PE0AGkJCJdIoDAARYzHbznDyYq7+O5FR7PV7vT7fX6IO65cgBKLVRLlFIBR5wkCNRHI1pojpEljsbF9QbDMYahjEmZGTTSdRbYzLMw4YxiJYABVUimkrNO7Mup2ufiS5AiMSicQC4XitgCthhIpuYXIUQikslwNsMXSoMVyuaKLaiiYTH4ACM8AAnXgCYRulxuDleL15MJ+XlhfJlOIAsVR3Kdwry55N+shPyRGLphGZtXkHN5wsl5RwMD0Rj4kaTgvFoQVs5Vz2ga65AcxIGpZ5vQOB5JR6HBeOff0PXIxCojppIlqoie51cl3V40Yr6dks0LStBZbXtCQnRdDcPU5WsED3F5D3rZ4AS+Eo4g7b4Y07SUQlw4MI2DJ8VVfbMP2nHE9SXP9i1LQR1wcNktxgndEACAoigeZIAgSEFAlyKMAwPL5oT4+CwjCKIiLHN9qK-XF9Vk2jy1yE5KwuZifG5GNbGqKU4lBb4g0CDsQhKcgARiYMniCVtwikl8swoRTvwUsiaL4OjrCiVTN3UmsWIQNj7k4oMeOs-jskQf0hNQnSnibao4ns1UZLcuTKN-NKJyLPBWEwfgqHcFgRk0FgyEwehIAon8RkZecWhKlgADNiCLABbPAujJZlFFUM0pAATTETRjEZclxF6ngxGMZQoKY-zNIQJJtKCKIAkCO9g3QyK4PvGNUjjSEPgSSVh3qJVRwc8dnPkqissUHK8oKor0Ea9BysqiBqv1Or6Aa0r0Ba9rOsxAD1BG7QJB6vrpAkAAxbR5Dmvz0C5OCdIbH0Ai7WxxJTPcOwiEIr1iKzAm494wmSkinKyly7qnGiHty2B8sK4kAY+qqPOEIwVB4LZLWUKHjF6-qEaRhj3Xm1HYNyHTCjDUyPgqFIPgiEzIQ43HwRCVIUyiSTzozK7UsZ9KasUsRiuZp72ZYADlGMZ0rWQIaRrGzQJtUKaZuR6tZYC5bzNW9aAk20yO35IE9bCNijp0wjjculLSPN76Gc-bKWbZl6RmMdA8HzQQIG60WYcG4bRvG+0fem2apbUgO0bies-SiQJcYSiJ7w1nbwhCchSiDXCpWxp5cmpxz33T+nMvT23Wee4kC6LkvHedxRXfd6uvdr32G586CFuuVuG2iTvxM7HvEgEiSJTecSgy7gozvO9AmAgOBvBN1OwEYlGaMAC0a0oxAKeBEcgMQwyfB4hJAE7wp7jkJEaLUPQAHN1gqAnaQDuKxjWhJeUTZUKGyQW+FBXRtTcB5hg7ci1oHinrNxCIQYmzQK+FGO4B48JhmqDCZ4kIAhkLaBQzEVCM4EkNFMdB0tAGwQDITGM+kYgBkhHEEoKZ4jCNpubWhGlrjYL+OGQEhDlrPEqHHbRM8s40NkZggKCidpdhjGxPWbw0IRhCFYxSs5YDzkXPPT8eiT6IAeB2CowV1FVHyPEWoydnx-2seROey40rBMDotWI4odJfGqAZUyYcozh27LYUo0CO4JEHJPeJxFp43Qyqk9Otim50O9KCcyuk8kSQKcZHaLDIGWWOiCPcCQwzeLprdQJ5FF65w5mVMAFVIDpJbj6cy6RTKDhyfpKIHZ5QHjDCUN4QRVoBnGbPSZjSs4zOXsVTmCzPoSNqvVIgb0gYdTocfDJu5AyDwfHuPhT9cZ+EJuCcyaQEEDjuLELxNTpJpyzikxS1z7avTuYsr6zTfL2MWuohs7wUwlGhIlXIOynH+kKKkD4dxIUWRhfCBJNMkk0URVla2r1kUvWWbBLGHTcn6W6UZAIGE1qxgstxWI-p-RJVhabeFySLlIsekvFF+dC7FyWXY1piACmxibLHAo2MWE-B2gGQelNgQJESPLIMdQ6hAA */
createMachine({
  id: 'SyncedMachine',
  tsTypes: {} as import('./Synced.fsm.typegen').Typegen0,
  context: {
    containerElement: {} as ContainerElement,
    containerElementPath: [] as Path,
  },
  schema: {
    events: {} as
      | { type: 'ON_SHOW_TRANSCLUSION_SELECTION' }
      | { type: 'ON_SELECT_EXISTING_TRANSCLUSION', transclusionID: string }
      | { type: 'ON_CLICK_OUTSIDE' }
      | { type: 'ON_TRIGGER_DETACH_FLOW' }
      | { type: 'ON_CANCEL_DETACH_FLOW' }
      | { type: 'ON_CLICK_OUTSIDE' }
      | { type: 'ON_DETACH_SYNCED_CONTAINER' }
      | { type: 'ON_CHANGE_ELEMENT_PATH', newPath: Path }
      | { type: 'ON_CREATE_SYNCED_CONTAINER', newTransclusionID: string },
  },
  states: {
    SuggestionsBox: {
      states: {
        Idle: {
          description: 'Idle state does not show suggestion box',

          on: {
            ON_SHOW_TRANSCLUSION_SELECTION: 'Showing Suggestion Box',
          },
        },

        'Showing Suggestion Box': {
          tags: ['ui:showing_suggestion_box'],
          on: {
            ON_SELECT_EXISTING_TRANSCLUSION: {
              target: 'Idle',
              actions: 'effectReplaceSlateNodeWithTransclusionContent',
            },

            ON_CLICK_OUTSIDE: {
              target: 'Idle',
              description: 'When clicking outside of the box should hide the suggestion box',
            },

            ON_CHANGE_ELEMENT_PATH: 'Idle',
          },
        },
      },

      initial: 'Idle',
    },

    Toolbar: {
      states: {
        Idle: {
          always: 'Showing Toolbar',
        },

        'Resetting Toolbar': {
          always: 'Showing Toolbar',
          description: `This is a temporary state where we reset the state of the Toolbar.

We want the toolbar to go through another transition from Idle into 1 of the stable states (Transclusion Enabled, Transclusion Connected, Non Transclusion)`,
        },

        'Showing Toolbar': {
          states: {
            Idle: {
              always: [{
                target: 'Transclusion Enabled',
                cond: 'isTransclusionEnabled',
              }, {
                target: 'Transclusion Connected',
                cond: 'isTransclusionConnected',
              }, 'Non Transclusion'],
            },

            'Transclusion Connected': {
              tags: ['ui:transclusion_connected'],

              states: {
                'Showing Detach Confirmation': {
                  tags: ['ui:showing_detach_confirmation'],
                  on: {
                    ON_DETACH_SYNCED_CONTAINER: {
                      target: '#SyncedMachine.Toolbar.Showing Toolbar.Non Transclusion',
                      description: 'Detach sync container from existing container',
                      actions: 'effectRemoveSlateNodeTransclusion',
                    },

                    ON_CANCEL_DETACH_FLOW: 'Idle',
                  },
                },

                Idle: {
                  on: {
                    ON_TRIGGER_DETACH_FLOW: 'Showing Detach Confirmation',
                  },
                },
              },

              initial: 'Idle',
            },

            'Non Transclusion': {
              tags: ['ui:non_transclusion'],
              on: {
                ON_CREATE_SYNCED_CONTAINER: {
                  target: 'Transclusion Connected',
                  description: 'Create new synced container',
                  actions: ['effectUpdateSlateNodeTransclusionID', 'createTransclusionReference'],
                },
              },
            },

            'Transclusion Enabled': {
              tags: ['ui:transclusion_enabled'],
              on: {
                ON_DETACH_SYNCED_CONTAINER: {
                  target: 'Non Transclusion',
                  actions: 'effectRemoveSlateNodeTransclusion',
                },

                ON_CREATE_SYNCED_CONTAINER: {
                  target: 'Transclusion Connected',
                  actions: ['createTransclusionReference', 'effectUpdateSlateNodeTransclusionID'],
                  description: 'Create new synced container',
                },
              },
            },
          },

          initial: 'Idle',

          on: {
            ON_CHANGE_ELEMENT_PATH: {
              target: 'Resetting Toolbar',
              description: 'Changes the currently selected synced element path',
              actions: 'assignSlateSyncedContainerDataToContext',
            },
          },
        },
      },

      initial: 'Idle',
    },
  },

  type: 'parallel',
}, {
  guards: {
    isTransclusionEnabled: (context) => (
      !!context?.containerElement?.transclusion_enabled
      && !context?.containerElement?.transclusion_reference_id
    ),
    isTransclusionConnected: (context) => (
      !!context?.containerElement?.transclusion_enabled
      && !!context?.containerElement?.transclusion_reference_id
    ),
  },
});

export type SyncedMachineType = typeof syncedMachine;
